<template>
  <div class="hab-modal">
    <div class="hab-modal__box">
      <div class="hab-modal__title">{{ $t('book.cancel_title') }}</div>
      <div class="hab-modal__content">
        <p>{{ $t('book.cancellation_sure') }}</p>
        <div>
          <label>{{ $t('book.cancellation_fee') }}:</label> <strong>{{ formatMoney(cancelFee) }} {{ currency }}</strong>
        </div>
        <div>
          <label>{{ $t('book.total_refund') }}:</label> <strong>{{ formatMoney(finalTotal - cancelFee) }} {{ currency }}</strong>
        </div>
      </div>
      <div class="hab-modal__footer">
        <div class="hab-modal__footer__item">
          <span @click="$emit('submit')">{{ $t('book.cancel_submit') }}</span>
        </div>
        <div class="hab-modal__footer__item">
          <span @click="$emit('close')">{{ $t('book.back') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatMoney} from "../../../utils/helpers";
export default {
  props: {
    cancelFee: {
      type: Number,
      default: 0
    },
    finalTotal: {
      type: Number,
      default: 0
    },
  },
  emits: ['close', 'submit'],
  data () {
    return {
    }
  },
  computed: {
    currency() {
      return this.$i18n.locale === "vn" ? "đ" : "VND";
    }
  },
  methods: {
    formatMoney
  }
};
</script>
